import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, ANALYTICS, ENTITLEMENT_ACTIVITYNAMES } from 'src/app/common/core/common.constants';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { Subscription } from 'rxjs';
import { SuccessComponent } from '../success/success.component';
import { PDLService } from 'src/app/services/pdl-service.service';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.scss']
})
export class EditPasswordComponent implements OnInit {
  editAction: boolean;
  authoringContentData: any;
  incorrectPAssword: boolean;
  newPassword: any;
  confirmPwdFlag: boolean;
  disableConfirmPinBtn: boolean;
  currentPinFlag: boolean;
  allowAction: boolean;
  currentPassword: any;
  inputText: any;
  confirmedPassword: any;
  banAddressPrimary: any;
  city: any;
  state: any;
  zipCode: any;
  name: any;
  banAddressOptional: any;
  linkSequenceNumber: any;
  addressId: any;
  continueButtonEnabled: boolean = false;
  showDefaultAddressPopup: boolean;
  stateOptions = COMMON_CONSTANTS.BILLING_ADDRESS_STATE_LIST;
  ban: any;
  ngbModalOptions: NgbModalOptions;
  errorMessage: any;
  isOpenFromAccountListing: boolean;
  selectedBanFromMeatbal: any;
  isEditPwdInlineError: boolean = false;
  issubmitReadOnly: boolean;
  billAddressReadOnly: boolean;

  constructor(private modalService: NgbModal,public utilsSvc: UtilsService , private _loaderSvc: LoaderService, private _cacheSvc: HttpCacheService,
              public manageLineService: ManageLineService, public helperUtilitySvc: HelperUtilityService, private pdlService: PDLService) { }

  disableConfirmPAssword: boolean;
  logonId: any;
  orgId: any;
  email: any;
  oldPassword: any;
  banDetails: any;
  banName: any;
  banNumber: any;
  banFriendlyNameSubscription: Subscription;

  ngOnInit() {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    this.incorrectPAssword=false;
    this.disableConfirmPinBtn = true;
    this.currentPinFlag = false;
    this.disableConfirmPAssword = true;
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.banDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.SELECTED_BAN_DETAIL));
    if(this.isOpenFromAccountListing){
      this.banDetails = this.selectedBanFromMeatbal;
    }
    this.banName = !isNullOrUndefined(this.banDetails) ? this.banDetails.banFriendlyName : '';
    this.banNumber =  !isNullOrUndefined(this.banDetails) ? this.banDetails.billingAccount : '';
    this.banFriendlyNameSubscription = this.manageLineService.banFriendlyName.subscribe((banFriendlyName: any) =>{
      if(!isNullOrUndefined(banFriendlyName)){
        this.banName = banFriendlyName;
      }
    });
    this.issubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.UPDATE_BILLING_ACCOUNT_PASSWORD);
    this.billAddressReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.DEFAULT_ADDRESS);
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName:this.authoringContentData.accountDetailsTab.editPassword,
    });
  }

  closePopupTagging(){
    this.modalService.dismissAll();
    this._loaderSvc.stop();
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.CLOSE,
      modalName: this.authoringContentData.accountDetailsTab.editPassword,
    });
  }
  cancelPopupTagging(){
    this.modalService.dismissAll();
    this._loaderSvc.stop();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName:this.authoringContentData.accountDetailsTab.cancelBtn,
      assetType: ANALYTICS.BUTTON,
      modalName:this.authoringContentData.accountDetailsTab.editPassword,
      userSelection:''
    });
  }

  closeModal(){
    this.modalService.dismissAll();
    this._loaderSvc.stop();
  }
  onFocusOut(inputTxt){
    this.inputText = inputTxt;
    this.editAction = false;
    this.incorrectPAssword=false;
    this.newPassword = this.inputText;
    if(!isNullOrUndefined(this.inputText) && this.inputText.length >COMMON_CONSTANTS.DIGITS.ZERO && this.inputText.length <COMMON_CONSTANTS.DIGITS.SIX){
      this.disableConfirmPAssword = true;
      this.confirmedPassword = '';
      this.incorrectPAssword = true;
    }else if(!isNullOrUndefined(this.inputText) && this.inputText.length === COMMON_CONSTANTS.DIGITS.ZERO ){
      this.disableConfirmPAssword = true;
      this.confirmedPassword = '';
      this.confirmPwdFlag=true;
    }
    else{
      this.incorrectPAssword = this.accountPasswordCheck(this.inputText);
      if(this.incorrectPAssword){
        this.disableConfirmPAssword = true;
        this.confirmedPassword = '';
      }
      else{
        this.disableConfirmPAssword = false;
      }
    }
    this.enableDisableButton();
  }
  preventAction(){
    this.editAction = true;
    return false;
  }
  preventActionforConfirmPassword(){
    this.allowAction = true;
    return false;
  }
  currentPinFocusOut(currentPwd){
    this.currentPassword = currentPwd;
    if(!isNullOrUndefined(this.currentPassword) && this.currentPassword != ""){
      this.currentPinFlag = true;
    }
    this.enableDisableButton();

  }
  onConfirmPwd(confirmPassword){
    this.confirmedPassword=confirmPassword;
    this.allowAction = false;
    if(this.newPassword == this.confirmedPassword){
      this.confirmPwdFlag = true;
    }else if(this.confirmedPassword.length == COMMON_CONSTANTS.DIGITS.ZERO ||this.confirmedPassword==''){
      this.confirmPwdFlag = true;
    }
    else{
      this.confirmPwdFlag = false;
    }
    this.enableDisableButton();
  }
  enableDisableButton(){
    if(this.currentPinFlag && !this.incorrectPAssword && this.confirmPwdFlag && this.confirmedPassword.length > COMMON_CONSTANTS.DIGITS.ZERO && this.currentPassword != "" && this.inputText != ""){
      this.disableConfirmPinBtn = false;
    }
    else{
      this.disableConfirmPinBtn = true;
    }
  } 
  accountPasswordCheck(pasword){     
    var regex=/^\d{6,15}$/;
    var passwordFlag = true;
    if(pasword.match(regex)){ 
        if(!pasword.match(/0[1-5]{5}|1[2-6]{5}|2[3-7]{5}|3[4-8]{5}|4[5-9]{5}/) && !pasword.match(/(.)\1{5,}/)){         
          passwordFlag= false;
        }        
    }
    return passwordFlag;    
  }
  openSuccessModel() {
    this._loaderSvc.start();
    const payload = {
      'billingAccount': !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY)) ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY) : '',
      'logonId': JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)).logonId,
      'newBillingAddress': {
        'zipCode': this.zipCode,
        'address2': this.banAddressOptional,
        'city': this.city,
        'address1': this.banAddressPrimary,
        'state': this.state
      },
      'orgId': this.helperUtilitySvc.getOrgID(),
      'email': JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)).logonId,
    };
    this._loaderSvc.start();
    this.manageLineService.updateBillingAddress(payload).subscribe((res) => {
      if (!isNullOrUndefined(res) && res.status === MANAGE_LINE_CONST.SUCCESS) {
        this.manageLineService.close();
        this._loaderSvc.stop();
        const successModelRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModelRef.componentInstance.header = this.authoringContentData.accountDetailsTab.addressSaveSuccessText;
        successModelRef.componentInstance.isBillingAddressUpdated = true;
      } else {
        this._loaderSvc.stop();
        this.utilsSvc.errorHandling(res);
      }
    }, (err) => {
      this.utilsSvc.errorHandling(err);
    });
  }

  onZipChange() {
    if (this.zipCode.length < 5) {
      this.continueButtonEnabled = false;
    } else {
      this.continueButtonEnabled = true;
    }
  }

  accountPasswordChange() {
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    this.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
    this.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
    this.oldPassword = this.currentPassword;
    this.newPassword = this.confirmedPassword;
    let ban = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY);
    if(this.isOpenFromAccountListing){
    ban = !isNullOrUndefined(this.selectedBanFromMeatbal) ? this.selectedBanFromMeatbal.billingAccount: '';
    }
    this.manageLineService.accountPasswordChange(ban, this.logonId, this.oldPassword, this.newPassword, this.email).subscribe((response) => {
      //Success
      if (response.status == MANAGE_LINE_CONST.SUCCESS) {
        this.isEditPwdInlineError = false;
        this.closeModal();
      } else {
        this.isEditPwdInlineError = true;
        this.errorMessage = response.message;
      }

    }, (err) => {
      this.isEditPwdInlineError = true;
      this.errorMessage = this.authoringContentData.accountDetailsTab.errorMessageBodyTxt;
    });

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData.accountDetailsTab.ChangePinBtn,
      assetType: ANALYTICS.BUTTON,
      modalName: this.authoringContentData.accountDetailsTab.editPassword,
      userSelection:''
    });
  }

  ngOnDestroy() {
    if (this.banFriendlyNameSubscription) {
      this.banFriendlyNameSubscription.unsubscribe();
    }
  }
}


